export const styles = {
  buttonWrapper: (theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      mt: 8,
      justifyContent: 'center',
    },
    zIndex: 2,
  }),
  marginTop: {
    marginTop: '30px',
  },
  wrapper: { display: 'block', position: 'relative' },
  slide: (marginTops, index, height) => {
    const countedHeight = index === 0 ? 220 : height;
    const blockTop = index > 0 ? 210 : 100;
    return {
      height: countedHeight,
      mt: marginTops[index],
      position: 'sticky',
      top: blockTop,
      transform: `translateY(${(index > 0 ? index - 1 : index) * 45}px)`,
    };
  },
};
